export default "__VITE_ASSET__BZjodCGO__"